import {useMutation} from '@tanstack/react-query';
import {PostAuthRequestParams} from 'domain/usecases/private/authorizations';
import {postAuthRequest} from '../services/postAuthRequest';

export const usePostAuthRequestMutation = () =>
	useMutation({
		mutationFn: (params: PostAuthRequestParams) => postAuthRequest(params, params.signal),
	});
